import { MediaDocument } from "@pathwright/graphql-client/src/generated"
import { graphql } from "@apollo/client/react/hoc"
import PropTypes from "prop-types"
import React, { Component } from "react"

class MediaQuery extends Component {
  render() {
    const { data, children } = this.props
    const { loading, error, media } = data || {}
    const { image, filestack } = media || {}
    return React.Children.only(children({ loading, error, image, filestack }))
  }
}

MediaQuery.displayName = "MediaQuery"

MediaQuery.propTypes = {
  children: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  blur: PropTypes.number,
  dpr: PropTypes.number,
  crop: PropTypes.string,
  fit: PropTypes.string
}

const mediaQuery = MediaDocument

export default graphql(mediaQuery, {
  options(props) {
    return {
      variables: {
        url: props.url,
        width: props.width,
        height: props.height,
        blur: props.blur,
        dpr: props.dpr,
        crop: props.crop,
        fit: props.fit ?? "clamp"
      }
    }
  },
  skip: ({ url }) => !url
})(MediaQuery)
